import { PortfolioDescription } from './portfolio';

class CustomerDescription {
    constructor(json) {
        if (json != null) {
            this.id = json.id;
            this.storageId = json.storageId;
            this.name = json.name;
            this.status = json.status;
            this.portfolio = new PortfolioDescription(json.portfolio);
            this.deliveryAddressId = json.deliveryAddressId;
            this.businessId = json.businessId;
            this.leadStage = json.leadStage;
            this.leadWonAt = json.leadWonAt;
            this.leadWonValue = json.leadWonValue;
            this.leadLostReasonCode = json.leadLostReasonCode;
            this.leadLostReasonText = json.leadLostReasonText;
        }
    }
}

export default CustomerDescription;
